//Reset data
export const RESET = "INBOX_UPDATE_RESET"

export const SET_IS_UPDATED = "INBOX_UPDATE_SET_IS_CREATE"
export const SET_NOT_UPDATED = "INBOX_UPDATE_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "INBOX_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "INBOX_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "INBOX_UPDATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "INBOX_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "INBOX_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "INBOX_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "INBOX_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "INBOX_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "INBOX_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "INBOX_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "INBOX_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "INBOX_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "INBOX_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "INBOX_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "INBOX_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "INBOX_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "INBOX_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "INBOX_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "INBOX_UPDATE_SET_MODAL_TYPE"